import styled from '@emotion/styled';
import type { ReactNode } from 'react';
import { Text } from '../../../../components';

interface FormFieldProps {
  label: string;
  required?: boolean;
  children: ReactNode;
  className?: string;
}

const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing(1)};
  width: 100%;
`;

const Label = styled(Text)`
  color: ${(props) => props.theme.colors.text.mediumLowEmphasis};
`;

export const FormField = ({ label, required = false, children, className }: FormFieldProps) => {
  return (
    <FieldContainer className={className}>
      <Label variant="body4" weight="bold">
        {label}
        {required && '*'}
      </Label>
      {children}
    </FieldContainer>
  );
};
